import React, { useState, useEffect } from "react";
import "./Category_Subcategory_Card.css";
import { useSelector, useDispatch } from "react-redux";
import { appSetup } from "../../../features/master/masterSlice";

const Category_Subcategory_Card = ({
  content,
  catDiscount,
  image,
  imgClassName,
  className,
  textClassName,
  alt,
}) => {
  const dispatch = useDispatch();

  const app_setup = useSelector((state) => state.master.app_setup);

  const discountPercentage =
    Number(catDiscount) > 0
      ? Number(catDiscount)
      : Number(app_setup?.global_discount) > 0
      ? Number(app_setup?.global_discount)
      : 0;

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  return (
    <section className="Category_Subcategory_Card">
      <div className={className}>
        {discountPercentage > 0 && (
          <div className="discount">{discountPercentage}% Off</div>
        )}

        <img src={image} className={imgClassName} alt={alt} />

        <div className="text-holder">
          <p className={textClassName}>{content}</p>
        </div>

        {/* <div className="bg-overlay"></div> */}
      </div>
    </section>
  );
};

export default Category_Subcategory_Card;
